module.exports = __webpack_public_path__ + "img/uptick_c5.d098b573.jpeg";